import { render } from "./AddressInput.vue?vue&type=template&id=995d6f74&scoped=true"
import script from "./AddressInput.vue?vue&type=script&lang=js"
export * from "./AddressInput.vue?vue&type=script&lang=js"

import "./AddressInput.vue?vue&type=style&index=0&id=995d6f74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-995d6f74"]])

export default __exports__